import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
    return (
        <div className="pattern-dots min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
            {/* Animated Background Blobs */}
            <div className="absolute top-20 right-20 w-96 h-96 bg-primary/10 rounded-full blur-3xl pulse-animation"></div>
            <div className="absolute bottom-20 left-20 w-96 h-96 bg-accent/10 rounded-full blur-3xl pulse-animation" style={{ animationDelay: '2s' }}></div>

            {/* Spinning Background Icons */}
            <div className="absolute top-10 left-10 opacity-5 spin-slow">
                <i className="fa-solid fa-person-running text-[200px] text-slate-400"></i>
            </div>
            <div className="absolute bottom-10 right-10 opacity-5 spin-slow" style={{ animationDelay: '-10s' }}>
                <i className="fa-solid fa-person-biking text-[180px] text-slate-400"></i>
            </div>

            <div className="relative z-10 max-w-4xl w-full">

                <div className="text-center">
                    <div className="mb-8 relative">
                        <h1 className="text-[180px] font-black gradient-text leading-none mb-4 drop-shadow-2xl">404</h1>
                        <div className="absolute inset-0 flex items-center justify-center opacity-10">
                            <i className="fa-solid fa-triangle-exclamation text-[200px] text-slate-400"></i>
                        </div>
                    </div>

                    <h2 className="text-4xl font-bold text-slate-800 mb-4">Oops! Page Not Found</h2>
                    <p className="text-xl text-slate-500 mb-8 max-w-2xl mx-auto leading-relaxed">
                        Looks like you've taken a wrong turn on your training route. The page you're looking for doesn't exist or has been moved.
                    </p>
                </div>

                <div className="flex items-center justify-center mt-12">
                    <Link
                        to="/login"
                        className="group px-12 py-4 bg-gradient-to-r from-primary to-cyan-500 hover:from-primary/90 hover:to-cyan-600 text-white rounded-xl font-semibold transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                    >
                        <i className="fa-solid fa-right-to-bracket text-lg"></i>
                        <span>Back to Login</span>
                    </Link>
                </div>

                <div className="text-center mt-8 text-slate-400 text-sm">
                    <p>Error Code: 404 | Page Not Found</p>
                </div>
            </div>

            <style>{`
                .pattern-dots {
                    background-color: #f1f5f9;
                    background-image: radial-gradient(#cbd5e1 1px, transparent 1px);
                    background-size: 30px 30px;
                }

                @keyframes float {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-30px) rotate(10deg); }
                }

                @keyframes pulse-slow {
                    0%, 100% { opacity: 0.3; }
                    50% { opacity: 0.6; }
                }

                .float-animation {
                    animation: float 8s ease-in-out infinite;
                }

                .pulse-animation {
                    animation: pulse-slow 4s ease-in-out infinite;
                }

                .gradient-text {
                    background: linear-gradient(135deg, #00adef 0%, #0891b2 50%, #06b6d4 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }

                @keyframes spin-slow {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }

                .spin-slow {
                    animation: spin-slow 20s linear infinite;
                }
            `}</style>
        </div>
    );
};

export default NotFound;
